import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Formik, FormikValues } from 'formik';
import * as yup from 'yup';

import { payTravel } from 'actions/adminTool';
import Header from 'components/AppBar';
import SubmitButton from 'components/Buttons/SubmitButton';
import FormikSubmitErrorEffect from 'components/FormikSubmitErrorEffect';
import Input from 'components/Input';
import { Desktop, Mobile } from 'components/Responsive';
import ScreenHeader from 'components/ScreenHeader';
import Section from 'components/Section';
import useToast from 'hooks/useToast';

import { Container, Wrapper, FormContainer, Field } from './styles';
import useStoreTranslation from 'hooks/useStoreTranslation';

const AdminToolAddExtraCharge = () => {
  const history = useHistory();
  const { t } = useStoreTranslation();
  const toast = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (values: any) => {
    try {
      setIsLoading(true);
      await payTravel(
        values.extraChargeItineraryId,
        values.originalTravelItineraryId,
        values.description,
        values.emailUser,
        values.countryId,
        values.costCenter,
      );
      toast.add({ type: 'success', message: t('adminTool.importExtraChargeForm.toastSuccess') });
    } catch (error) {
      if (error?.response?.data?.error.includes('BRANCH CODE')) {
        toast.add({ type: 'danger', message: ` ${t('adminTool.importExtraChargeForm.toastErrorTitle')} ${t('adminTool.importExtraChargeForm.toastErrorDescription')}`});
      } else {
        toast.add({ type: 'danger', message:` ${error.toString()} - ${error?.response?.data?.error} ` }); 
      }      
    }

    setIsLoading(false);
  };

  const validationSchema = yup.object().shape({
    extraChargeItineraryId: yup.number().required(),
    originalTravelItineraryId: yup.number(),
    description: yup.string().required(),
    emailUser: yup.string().email().required(),
    countryId: yup.string().required(),
    costCenter: yup.string(),
  });

  const initValues = {
    extraChargeItineraryId: 0,
    originalTravelItineraryId: 0,
    description: '',
    emailUser: '',
    countryId: 'CO',
    costCenterCode: ''
  };

  return (
    <Wrapper className="target">
      <>
        <Mobile>
          <Header goBack={() => history.push('/corporate/booking')}>{t('adminTool.importExtraChargeForm.title')}</Header>
        </Mobile>

        <Desktop>
          <ScreenHeader title={t('adminTool.importExtraChargeForm.title')} subtitle={t('adminTool.importExtraChargeForm.subtitle')} />
        </Desktop>

        <Container>
          <Formik
            initialStatus={{ rightCheckIfIsValid: true }}
            initialValues={initValues}
            validationSchema={validationSchema}
            onSubmit={(value) => handleSubmit(value)}
            isInitialValid={(formik: FormikValues) => validationSchema.isValidSync(formik.initialValues)}
          >
            {({ dirty, isSubmitting, isValid, values, setFieldValue }: FormikValues) => (
              <>
                <FormikSubmitErrorEffect />
                <FormContainer marginBottom={dirty}>
                  <Section title={t('adminTool.importExtraChargeForm.parameters')} joinContent={false}>
                    <Field name="extraChargeItineraryId" label={t('adminTool.importExtraChargeForm.itineraryId')}>
                      <Input placeholder="" />
                    </Field>
                    <Field name="originalTravelItineraryId" label={t('adminTool.importExtraChargeForm.originalItineraryId')}>
                      <Input placeholder="" />
                    </Field>
                    <Field name="countryId" label={t('adminTool.importExtraChargeForm.country')}>
                      <Input placeholder="CO" maxLength={2} />
                    </Field>
                    <Field name="description" label={t('adminTool.importExtraChargeForm.description')}>
                      <Input placeholder="" />
                    </Field>
                    <Field name="emailUser" label={t('adminTool.importExtraChargeForm.email')}>
                      <Input placeholder="email@email.com" />
                    </Field>
                    <Field name="costCenter" label={t('adminTool.importExtraChargeForm.costCenter')}>
                      <Input placeholder="CC-1020" />
                    </Field>
                    <br />
                    <br />
                  </Section>
                  <SubmitButton dirty={true} isEdit loading={isLoading}>
                    {t('adminTool.importExtraChargeForm.button')}
                  </SubmitButton>
                </FormContainer>
              </>
            )}
          </Formik>
        </Container>
      </>
    </Wrapper>
  );
};

export default AdminToolAddExtraCharge;
